<!-- for loading data that cannot be soft deleted -->
<template>
    <v-autocomplete
        dense
        :error="errorBorder"
        :clearable="clearable && !readonly"
        :error-messages="$props.error"
        :items="options"
        :label="label"
        :readonly="readonly"
        :disabled="disabled"
        :hide-details="hideDetails"
        item-text="label"
        item-value="value"
        outlined
        v-model="selectedValue"
    >
        <template #prepend-item>
            <slot name="firstItem"></slot>
        </template>
        <template #prepend>
            <slot name="prepend"></slot>
        </template>
        <template slot="item" slot-scope="{item}">
            <span
                ><v-icon v-if="item.icon" :color="item.iconColor ? item.iconColor : ''" style="margin-right: 10px">{{
                    item.icon
                }}</v-icon
                >{{ item.label != null && item.label != undefined ? item.label : item }}</span
            >
        </template>
        <template slot="selection" slot-scope="{item}">
            <span
                ><v-icon v-if="item.icon" :color="item.iconColor ? item.iconColor : ''" style="margin-right: 10px">{{
                    item.icon
                }}</v-icon
                >{{ item.label != null && item.label != undefined ? item.label : item }}</span
            >
        </template>
    </v-autocomplete>
</template>

<script>
export default {
    name: 'Dropdown2',
    props: {
        readonly: Boolean,
        disabled: Boolean,
        value: [String, Number, Boolean, Object],
        ajax: Boolean,
        data: [Array, String],
        label: String,
        errorBorder: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            endpoint: '',
            selectedValue: null,
            options: [],
            ajaxLoaded: false,
            protected: null,
            latestValue: null,
        };
    },
    computed: {
        hideDetails() {
            return this.$props.error === '';
        },
    },

    watch: {
        value: function (newVal, oldVal) {
            if (newVal != oldVal) {
                if (newVal != this.selectedValue) {
                    this.setValue(newVal);
                }
            }
        },
        selectedValue: function (val) {
            if (val != this.$props.value) {
                if (val != null) {
                    if (val != this.$props.value) {
                        this.$nextTick(() => {
                            this.$emit('input', val);
                            const selectedItem = this.options.find((item) => item.value === this.selectedValue);
                            if (selectedItem) {
                                this.$emit('selected', {
                                    id: this.selectedValue,
                                    label: selectedItem.label,
                                });
                            }
                        });
                    }
                } else {
                    this.$nextTick(() => {
                        this.$emit('input', null);
                    });
                }
                this.$nextTick(() => {
                    this.callChange();
                });
            }
        },
    },
    methods: {
        callChange() {
            this.$emit('changes');
        },
        setValue(newVal) {
            this.selectedValue = newVal;
            if (!this.$props.ajax) {
                this.options = this.$props.data;
            }
        },
    },
    created() {
        var vm = this;
        if (this.$props.ajax) {
            this.$APICall(
                'get',
                'select/' + this.$props.data,
                {},
                (data, success) => {
                    if (success) {
                        vm.options = data;
                    }
                },
                false,
            );
        }
    },
    mounted() {
        this.setValue(this.$props.value);
    },
};
</script>

<style scoped></style>
